export default __webpack_public_path__ + "static/media/myimg.115e8441.JPEG";